export default { 
 common: { 
 unit: 'USDT', 
 day: 'день', 
 week: 'неделя', 
 save: 'сохранить', 
 submit: 'отправить', 
 confirmtitle: 'Подтвердить действие', 
 confirm: 'подтвердить', 
 reset: 'сбросить', 
 refresh: 'обновить', 
 copy: 'копировать', 
 copysuccessful: 'Копирование успешно', 
 modify: 'изменить', 
 binding: 'привязать', 
 finished: 'завершено', 
 canceled: 'отменено', 
 cancel: 'отменить', 
 all: 'все', 
 back: 'назад', 
 loading: 'загрузка...', 
 nomore: 'Все записи', 
 errortxt: 'Не удалось загрузить', 
 loosing: 'Отпустите, чтобы обновить...', 
 pulling: 'Потяните вниз, чтобы обновить...', 
 nodata: 'Пока нет записей', 
 buy: 'купить', 
 buyup: 'купить рост', 
 buydown: 'купить падение', 
 sell: 'продать', 
 forserver: 'Обратиться к службе поддержки', 
 total: 'итого', 
 status1: 'Ожидает проверки', 
 status2: 'Завершено', 
 status3: 'Не прошло', 
 paytype1: 'TRC20', 
 paytype2: 'ERC20', 
 paytype3: 'банковский перевод', 
 }, 
 footer: { 
 home: 'Главная', 
 market: 'Котировки', 
 exchange: 'Обмен валют', 
 options: 'Опционы', 
 assets: 'Активы', 
 change: 'Перевод', 
 recharge: 'Пополнение', 
 withdrawal: 'Вывод' 
 }, 
 home: { 
 menu1: 'Торговля опционами', 
 menu1desc: 'Поддерживает BTC/USDT и другие', 
 menu2: 'Быстрый пополнение', 
 menu3: 'Вывод', 
 menu4: 'Онлайн-поддержка', 
 menu5: 'Мгновенный обмен', 
 menu6: 'Помощь в заимствовании', 
 menu7: 'Стакинг', 
 menu8: 'Залог', 
 menu9: 'Перевод между счетами', 
 ranktitle: 'Рейтинг роста', 
 name: 'Название', 
 price: 'Последняя цена', 
 risefall: 'Изменение цены', 
 }, 
 register: { 
 register: 'Регистрация', 
 login: 'Вход', 
 email: 'Электронная почта', 
 phone: 'Номер телефона', 
 accountplaceholder: 'Введите аккаунт', 
 emailplaceholder: 'Введите электронную почту', 
 phoneplaceholder: 'Введите номер телефона', 
 pwdplaceholder: 'Введите пароль', 
 pwdplaceholder1: 'Пароль должен быть от 6 до 20 символов, включая буквы и цифры', 
 agepwdplaceholder: 'Повторите пароль', 
 agepwdplaceholder1: 'Пароли не совпадают', 
 invitecodeplaceholder: 'Введите инвайт-код', 
 remember: 'Запомнить пароль', 
 fotget: 'Забыли пароль' 
 }, 
 market:{ 
 title: 'Котировки', 
 all: 'Все' 
 }, 
 member:{ 
 reputation:'Рейтинг доверия', 
 identity_authentication:'Удостоверение личности', 
 under_review:'В процессе проверки', 
 certified:'Проверено', 
 awaiting_certification:'Ожидает проверки', 
 binding_withdrawal_address: 'Привязать адрес для вывода', 
 currently_selected_currency:'Выбранная валюта', 
 withdrawal_address:'Адрес вывода', 
 sharing_link:'Моя ссылка для распространения', 
 my_promotion_code:'Мой промо-код', 
 promotion_code:'Промо-код', 
 system_message:'Системные сообщения', 
 night_mode:'Ночной режим', 
 security_center:'Центр безопасности', 
 seted: 'Установлено', 
 noset: 'Не установлено', 
 login_password:'Пароль для входа', 
 transaction_password:'Пароль для вывода', 
 app_download:'Скачать приложение', 
 log_out:'Выход', 
 aboutus: 'О нас' 
 }, 
 identity:{ 
 title: 'Удостоверение личности', 
 name: 'Имя', 
 nameplaceholder: 'Введите истинное имя', 
 uploader: 'Загрузить фотографию удостоверения личности', 
 tip1: 'Загрузить лицевую сторону удостоверения личности', 
 tip2: 'Загрузить обратную сторону удостоверения личности' 
 }, 
 address: { 
 title: 'Привязать адрес для вывода', 
 bType: 'Выбранная валюта', 
 address: 'Адрес вывода', 
 addressplaceholder:'Введите адрес вывода', 
 }, 
 security:{ 
 title: 'Центр безопасности', 
 modifypwd: 'Пароль для входа', 
 resetlegalpwd: 'Пароль для транзакций', 
 loginpwd: 'Новый пароль для входа', 
 pwdage: 'Подтверждение пароля', 
 loginpwdplaceholder:'Введите текущий пароль для входа', 
 loginnewpwdplaceholder: 'Введите новый пароль для входа', 
 moneypwd: 'Введите пароль для транзакций', 
 pwdageplaceholder:'Повторите пароль' 
 }, 
 trade:{ 
 title: 'Обмен валют', 
 price: 'Цена', 
 num: 'Количество', 
 entrust: 'Текущие поручения', 
 clinch: 'Фактические сделки', 
 used: 'Доступно', 
 buyed: 'Можно купить', 
 amount: 'Объем сделок', 
 limitprice: 'Лимитная цена', 
 marketprice: 'Рыночная цена', 
 forprice: 'По текущей наилучшей цене', 
 errorMoney: 'Недостаточно доступного баланса', 
 priceerror: 'Введите цену поручения', 
 numerror: 'Введите количество поручения', 
 moneyerror: 'Введите сумму поручения', 
 }, 
 assets:{ 
 allconvert:'Общая стоимость активов', 
 usenum: 'Доступно', 
 freeze: 'Заблокировано', 
 convert: 'Конвертация', 
 tab1:'Активы', 
 tab11: 'Общая стоимость активов', 
 tab12: 'Стоимость опционов', 
 tab13: 'Стоимость средств', 
 tab14: 'Стоимость квантовых инвестиций', 
 tab2:'Опционы', 
 tab21: 'Счет опционов', 
 tab3:'Средства', 
 tab31:'Счет средств', 
 tab4:'Квантовые инвестиции', 
 tab41:'Счет квантовых инвестиций', 
 tbhead1: 'Финансовые записи', 
 tbhead2: 'Записи вывода', 
 tbhead3: 'Записи пополнения', 
 tbhead4: 'Записи перевода', 
 rcdnum: 'Количество', 
 rcd: 'Запись', 
 rcdtime: 'Время' , 
 rcdstatus: 'Статус', 
 rcddesc: 'Примечание', 
 rcdaddress: 'Адрес пополнения' 
 }, 
 change:{ 
 title: 'Перевод', 
 from: 'Из {name}', 
 to: 'В {name}', 
 frmtitle: 'Количество перевода', 
 inputplaceholder: 'Введите количество перевода', 
 btntxt:'Перевести' 
 }, 
 recharge:{ 
 title: 'Пополнение', 
 bType: 'Выбранная валюта', 
 address: 'Адрес пополнения', 
 token: 'Документ о платеже', 
 tokenplaceholder: 'Пожалуйста, загрузите документ о платеже', 
 num: 'Сумма пополнения', 
 numplaceholder: 'Введите сумму', 
 btn: 'Отправить на проверку', 
 bankname: 'Название банка', 
 bankno: 'Номер счета', 
 accountname: 'Название получательного счета', 
 bankaddress: 'Адрес банка', 
 bankcode: 'Банковский код', 
 companyaddress: 'Адрес компании' 
 }, 
 withdrawal:{ 
 title:'Вывод', 
 frmtitle1: 'Количество', 
 frmplaceholder1: 'Сумма вывода должна быть в диапазоне от {min} до {max}', 
 frmtitle2: 'Пароль для транзакций', 
 frmplaceholder2: 'Введите пароль для транзакций', 
 getnum: 'Сумма поступления', 
 fee:'Комиссия', 
 btn: 'Вывод' 
 }, 
 exchangeb:{ 
 title: 'Обмен', 
 account: 'Счет', 
 btn: 'Обменять', 
 numerror: 'Введите количество для обмена' 
 }, 
 option:{ 
 title: 'Опционы', 
 typetitle: 'Секундные контракты', 
 listtitle: 'Позиции', 
 kline: 'Кандлестики', 
 high: 'Максимум', 
 low: 'Минимум', 
 nums: 'Объем за 24 часа', 
 time: 'Время', 
 transaction: 'Режим торговли', 
 quantity: 'Количество открытых позиций', 
 quantityerror: 'Введите количество открытых позиций', 
 times: 'Время открытия позиций', 
 times1: 'Время расчета',
 account: 'Баланс счета', 
 buyup:'Купить рост', 
 buydown: 'Купить падение', 
 tab1: 'Список позиций', 
 tab2: 'История ордеров', 
 num: 'Количество', 
 price1: 'Цена покупки', 
 price2: 'Цена продажи', 
 profitandloss: 'Ожидаемая прибыль/убыток', 
 profitandloss1: 'Прибыль/убыток', 
 countdown: 'Отсчет', 
 waitfinish: 'Ожидает расчета', 
 finishing: 'В процессе расчета...', 
 finished: 'Расчет завершен', 
 order_price: 'Текущая цена', 
 order_cycle: 'Цикл', 
 order_type: 'Тип', 
 order_money: 'Сумма', 
 order_time: 'Время открытия позиции', 
 order_get: 'Прибыль', 
 order_btn: 'Продолжить открывать ордера' 
 }, 
 tradelst:{ 
 title: 'Мои поручения', 
 tab1: 'Поручения', 
 tab2: 'Завершенные сделки', 
 tab3: 'Отмененные', 
 usdtnum: '' 
 }, 
 loans:{ 
 title: 'Помощь в заимствовании', 
 order_tab: 'Заявки на заем', 
 pro_tab: 'Продукты займа', 
 Institution:'Кредитор', 
 Amount: 'Сумма', 
 DailyInterest:'Ежедневная процентная ставка', 
 RepaymentPeriod:'Срок погашения', 
 Application: 'Заявить на заем', 
 orderno: 'Номер заказа', 
 AllInterest: 'Общая сумма процентов', 
 RepaymentDate:'Дата погашения', 
 RepaymentMethod: 'Способ погашения', 
 Onetime: 'Одноразово', 
 Expected_loan_amount:'Ожидаемая сумма займа', 
 Expected_loan_amounterror:'Сумма займа должна быть в диапазоне от {min} до {max}', 
 imgplaceholdr: 'Кредитование по кредитной истории (обязательно, чтобы изображение было четким)', 
 icon1: 'Загрузить лицевую сторону документа', 
 icon2: 'Загрузить обратную сторону документа', 
 icon3: 'Загрузить фотографию с документом в руках', 
 status1: 'В обработке', 
 status2: 'Заявка одобрена', 
 status3: 'Заявка отклонена', 
 }, 
 lockming:{ 
 title: 'Стакинг', 
 order_tab: 'Заявки на майнинг', 
 pro_tab: 'Рынок майнинга', 
 locknum: 'Минимальное количество для стакинга', 
 getforday: 'Доходность/день', 
 days: 'Дней', 
 estimation: 'Предполагаемый доход', 
 real: 'Получено', 
 balance: 'Баланс кошелька', 
 nums: 'Количество для стакинга', 
 tolockming: 'Стакинг', 
 stime: 'Время начала', 
 etime: 'Время окончания', 
 }, 
 transfer:{ 
 title: 'Перевод между счетами', 
 searchtxt: 'Введите номер счета получателя', 
 ReceivingAccount: 'Информация о счете получателя', 
 toaccount: 'Счет', 
 confirmtxt: 'Пожалуйста, подтвердите счет получателя', 
 confirmedtxt: 'Счет получателя подтвержден', 
 numtxt: 'Сумма перевода', 
 numerror: 'Введите сумму перевода', 
 fee: 'Перевод внутри системы - бесплатно', 
 ArrivalTime: 'Время поступления', 
 Immediately: 'Поступление сразу', 
 realnum: 'Фактическая сумма поступления', 
 btn: 'Подтвердить перевод', 
 transfering: 'В процессе перевода', 
 orderNo: 'Номер заказа', 
 stime: 'Время перевода', 
 etime: 'Время поступления', 
 receiving: 'Счет получателя', 
 type: 'Валюта', 
 num: 'Сумма перевода', 
 arrivalnum: 'Сумма поступления' 
 }, 
 staking:{ 
 title: 'Залог', 
 record: 'Записи', 
 getforyear: 'Приблизительная годовая доходность', 
 time: 'Срок инвестирования', 
 snum: 'Минимальное количество для вклада', 
 snumerror: 'Введите количество для вклада', 
 snumerror1: 'Минимальное количество для вклада не должно быть меньше {num}', 
 join: 'Присоединиться сейчас', 
 opentime: 'Время открытия вклада', 
 money: 'Сумма вклада', 
 days: 'Период', 
 recordget: 'Годовая доходность', 
 gets: 'Доход', 
 stime: 'Дата начала', 
 etiem: 'Дата окончания', 
 redeemStaking: 'Возврат', 
 status0: 'В залоге', 
 status1: 'Вклад завершен', 
 status2: 'Возврат вклада', 
 }, 
 bank:{ 
 title: 'Привязать банковскую карту', 
 bankName: 'Название банка', 
 bankNameError: 'Введите название банка', 
 usrName: 'Владелец карты', 
 usrNameError: 'Введите имя владельца карты', 
 cardCode: 'Номер карты', 
 cardCodeError: 'Введите номер карты', 
 towallet: 'Вывод на кошелек', 
 tobank: 'Вывод на банковскую карту', 
 sendcode: 'Отправить код подтверждения', 
 sended: '{num} секунд до повторной отправки', 
 verify_code: 'Введите код подтверждения' 
 } 
}
